// Order-funnel beacons, giving the React shop the same three funnel steps the
// classic PHP sites have had for years (SetVS in their main.js):
//
//   vehicle picked   -> POST /visitor_session {vehicle_id}  -> API emits Order_Start
//   added to cart    -> POST /visitor_session {product_id}  -> API emits Order_Cart
//   checkout opened  -> POST /visitor_session {combined: 1} -> API emits Order_Start
//
// The API (visitor_session#Post) deduplicates Order_Start to ONE per session via
// the ga_event_sent flag, so firing it from both the picker and the checkout is
// safe — whichever happens first wins. vehicle_id/product_id are also stamped
// onto the session's durable visitor_session_utm row (migration 20260727_f),
// which feeds order#AutoMatchVisitorSession's car-veto when an operator later
// takes this caller's order by phone — instrumentation and matching improve
// together.
//
// Server pings are first-party and NOT consent-gated (statistics only, no
// cookies, no third party); the GA4 events ARE consent-gated via gaTrackEvent.
import apiClient from '../api/client';
import { gaTrackEvent } from './analytics';

// One GA event per page load for the "start" steps (the API dedups per session
// anyway; the guard just avoids noisy repeats while browsing back and forth).
let startNotified = false;

/** The visitor identified their car in the akkuválasztó (classic Order_Start). */
export function notifyVehicleSelected(vehicleId: number): void {
	if (!Number.isFinite(vehicleId) || vehicleId <= 0) return;

	if (!startNotified) {
		startNotified = true;
		gaTrackEvent('Order_Start');
	}

	apiClient.post('/visitor_session', { vehicle_id: String(vehicleId) }).catch(() => {});
}

/** A battery was added to the cart (classic Order_Cart, one event per add). */
export function notifyOrderCart(productId: number): void {
	if (!Number.isFinite(productId) || productId <= 0) return;

	gaTrackEvent('Order_Cart');

	apiClient.post('/visitor_session', { product_id: String(productId) }).catch(() => {});
}

/** The checkout page opened (Order_Start for visitors who skipped the picker). */
export function notifyCheckoutStarted(): void {
	if (!startNotified) {
		startNotified = true;
		gaTrackEvent('Order_Start');
	}

	apiClient.post('/visitor_session', { combined: '1' }).catch(() => {});
}
